app.service("StaffOrderReplacementService", ['$rootScope', function ($rootScope) {

    const siteHelper = $rootScope.site_helper;
    const requestService = $rootScope.service.request;

    const StaffOrderReplacementModel = function () {
        this.list_request_in_progress = false;
        this.remake_reasons = null;
        this.choices = {};
        this.choice_order = [];
        this.choice_list = [];
        this.listRequestCallbacks = [];
        this.requestStaffReplacementList = requestStaffReplacementList;
        this.requireRemakeReasons = requireRemakeReasons;
    };

    this.model = new StaffOrderReplacementModel();
    const model = this.model;

    function requestStaffReplacementList(callback) {
        if (callback) {
            model.listRequestCallbacks.push(callback);
        }
        if (model.list_request_in_progress) {
            return
        }
        model.list_request_in_progress = true;
        const endpoint = '/request/api.php/replacements/pending';
        requestService.getRequest(endpoint, function (success, data, messages) {
            model.list_request_in_progress = false;
            let i;
            if (success) {
                model.choice_order.length = 0;
                for (i = 0; i < data.length; i++) {
                    const staffReplacement = data[i];
                    const customerCode = staffReplacement.customer_code;
                    model.choice_order.push(customerCode)
                    model.choices[customerCode] = staffReplacement;
                    model.choice_list.push(staffReplacement)
                }
            }
            for (i = 0; i < model.listRequestCallbacks.length; i++) {
                model.listRequestCallbacks[i](success, model.choice_list, messages);
            }
            model.listRequestCallbacks.length = 0;
        })
    }

    this.requestStaffReplacementEntry = function (customerCode, callback) {

        const endpoint = '/request/api.php/replacements/pending/' + customerCode;
        requestService.getRequest(endpoint, callback)
    }

    function requireRemakeReasons(callback) {
        if (model.remake_reasons) {
            if (callback) {
                callback(true, model.remake_reasons.choice_list);
            }
            return;
        }
        const endpoint = '/request/api.php/replacements/remake_reasons';
        requestService.getRequest(endpoint, function (success, data, messages) {
            if (success) {
                const choices = {};
                const choiceList = [];
                for (let key in data) {
                    const remakeReason = data[key];
                    choices[remakeReason.id] = remakeReason;
                    choiceList.push(remakeReason);
                }

                choiceList.sort(function (a, b) {
                    if (a.id < b.id) {
                        return -1;
                    }
                    if (a.id > b.id) {
                        return 1;
                    }
                    return 0;
                })
                model.remake_reasons = {
                    choices: choices,
                    choice_list: choiceList
                }
            }
            if (callback) {
                callback(success, model.remake_reasons.choice_list, messages);
            }
        })
    }

    this.submitStaffReplacement = function (staffReplacement, callback) {

        const endpoint = '/request/api.php/replacements/submit';

        requestService.postJsonRequest(endpoint, staffReplacement, function (success, staffReplacement, errors) {

            if (staffReplacement) {
                if (staffReplacement._errors) {
                    success = false;
                    siteHelper.addErrorMessage(staffReplacement._errors, errors);
                }
            }
            if (callback) {
                callback(success, staffReplacement, errors);
            }
        })
    }

}])